import * as React from 'react';

import { Node, SELECT_PROFILE, COLLAPSE_MENU } from '../store/profile';
import { RootState } from '../store';
import { Action, Dispatch } from 'redux';
import { returntypeof } from '../helper';
import { connect } from 'react-redux';
import { LOGOUT, TOGGLE_CHECKOUT, TOGGLE_DOWNLOAD, TOGGLE_THANKYOU } from '../store/login';

const mapStateToProps = (state: RootState) => ({
    profiles: state.profile.profiles,
    selected: state.profile.selected,
    lookup: state.info.lookup,
    ticket: state.login.ticket,
    payment_gateway: state.login.payment_gateway,
    loaded: state.profile.loaded,
    num_photos: state.photo.selected.size,
    fields: state.login.profile_fields,
    selected_dl: state.photo.selected,
    webshop: state.webshop,
    collapsed: state.profile.collapsed,
    bricks: state.photo.bricks,
    photo: state.photo,
    login: state.login,
});

const mapDispatchToProps = (dispatch: Dispatch<Action>) => ({
    toggleProfile: (selected?: number) => () => {
        dispatch({ type: SELECT_PROFILE, selected })
    },
    toggleFilter: (selected?: number) => {
        dispatch({ type: SELECT_PROFILE, selected })
    },
    toggleCollapse: () => {
        dispatch({ type: COLLAPSE_MENU })
    },
    toggleCheckout: () => {
        dispatch({ type: TOGGLE_CHECKOUT })
    },
    toggleDownload: () => {
        dispatch({ type: TOGGLE_DOWNLOAD })
    },
    logout: () => {
        dispatch({ type: LOGOUT })
    },
    toggleThankyou: () => {
        dispatch({ type: TOGGLE_THANKYOU })
    },
});

const stateProps = returntypeof(mapStateToProps);
const dispatchProps = returntypeof(mapDispatchToProps);

type Props = typeof stateProps & typeof dispatchProps;

type State = {
    collapsed: boolean;
    showMenu: boolean;
    webshop: boolean;
}

export interface Filter {
    type: string,
    value: string
}

export interface Events {
    title: string
}


class Sidebar extends React.Component<Props, State> {

    constructor(props: Props) {
        super(props);
        this.state = {
            collapsed: false,
            showMenu: false,
            webshop: false,
        }
    }


    renderDetails = () => {
        let resp: React.ReactElement[] = [];

        let profile = this.props.profiles[this.props.selected || 0];
        if (this.props.selected != undefined) {
            try {
                this.props.fields.forEach(field => {
                    let nice_name = this.props.lookup[field] || field;
                    if (profile[field] != undefined && field != "id" && field != "sb_profileName") {
                        resp.push(<span key={field} style={{ paddingLeft: '23%' }}><strong>{nice_name}: </strong> {profile[field]} <br /></span>)
                    }
                })
            } catch {

            }
        }


        return resp;
    }


    onDownloadClick = (e: React.MouseEvent<any>) => {
        let ticket = encodeURIComponent(this.props.ticket || "");

        let ids = Array.from(this.props.selected_dl).join(",");

        window.open(`/api/v1/download/original/${ids}?sbpportal-ticket=${ticket}`, "_blank");

        e.stopPropagation();
        e.preventDefault();
    }

    renderActions() {
        return (
            <div className={this.props.collapsed ? "side-bar-actions collapsed" : "side-bar-actions"}>
                <button className={this.props.collapsed ? "btn btn-primary" : "btn btn-linked"} onClick={this.props.toggleCollapse}><i className="fas fa-bars"></i></button>
            </div>
        )
    }

    toggleMenu = () => {
        this.setState({ showMenu: !this.state.showMenu })
    }

    inIframe = () => {
        try {
            return window.self !== window.top;
        } catch (e) {
            return true;
        }
    }

    public render() {
        let downloadImg = <img className="icon svg" src="/assets/icons/icon39.svg"></img>
        let logo;
        if(this.inIframe() == false){
            logo = <li className="logo"><img src="/api/asset/logo" alt="" width="180px" height=""></img></li>
        }
        

        let detailTitle;
        if (this.state.webshop != this.props.login.webshop) {
            this.setState({ webshop: !this.state.webshop })
        }

        if (this.props.selected != undefined) {
            detailTitle = <h5>Details:</h5>
        }

        let itemCount;
        if (this.props.num_photos > 0) {
            itemCount = <span className="item-count">{this.props.num_photos}</span>
        }

        let showDisplay = "";
        if (this.props.login.webshop == false && this.props.webshop.orders.size == 0) {
            showDisplay = "none";
        }

        return (
            <div className="theme-Ecommerce-menu">
                <div className="d-flex justify-content-between align-items-center">
                    <div className="left-content">
                        <ul>
                            {logo}
                        </ul>
                    </div>
                    <div className="right-content">
                        <ul>
                            <li className="action-list-item cart-action-wrapper">
                                <div className="dropdown" style={{ display: this.props.login.webshop ? "" : "none" }}>
                                    <button className="dropdown-toggle" onClick={this.props.toggleCheckout}>
                                        <img src="/assets/icons/icon37.svg" alt="" />
                                        {itemCount}
                                    </button>
                                </div>
                            </li>
                            <li className="action-list-item user-profile-action">
                                <div className="dropdown">
                                    <button className="dropdown-toggle" data-toggle="dropdown">
                                        <img src="/assets/icons/icon38.svg" alt=""></img>
                                    </button>
                                    <div className="dropdown-menu dropdown-menu-right">
                                        <ul>
                                            <li style={{ display: showDisplay }}><a onClick={this.props.toggleDownload} style={{ cursor: "pointer" }}>{downloadImg} My downloads</a></li>
                                            <li style={{ display: this.props.login.webshop ? "" : "none" }}><a onClick={this.props.toggleCheckout} style={{ cursor: "pointer" }}><img src="/assets/icons/icon37.svg" alt="" className="icon svg"></img> Shopping Cart</a></li>
                                            <li style={{ display: this.props.login.auth == "schoolbox" ? "none" : ""}}><a onClick={this.props.logout} style={{ cursor: "pointer", display: this.props.login.auth != "schoolbox" ? "" : "none" }}><img src="/assets/icons/icon40.svg" alt="" className="icon svg"></img> Logout</a></li>
                                        </ul>
                                    </div>
                                </div>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        )

    }

}

export default connect(mapStateToProps, mapDispatchToProps)(Sidebar);